import { IconInfoCircle, IconPointFilled } from "@tabler/icons-react";
import { PropsWithChildren } from "react";

export enum BadgeType {
  label = "label",
  icon = "icon",
  dotted = "dotted",
}

export enum BadgeColor {
  white = "white",
  pink = "pink",
  green = "green",
  blue = "blue",
  amber = "amber",
  purple = "purple",
  red = "red",
  gray = "gray",
}

interface BadgeProps {
  type?: BadgeType | `${BadgeType}`;
  color?: BadgeColor | `${BadgeColor}`;
  disabled?: boolean;
}

const backgroundColors: Record<BadgeColor, string> = {
  white: "bg-badge-white-bg",
  pink: "bg-badge-pink-bg",
  green: "bg-badge-green-bg",
  blue: "bg-badge-blue-bg",
  amber: "bg-badge-amber-bg",
  purple: "bg-badge-purple-bg",
  red: "bg-badge-red-bg",
  gray: "bg-badge-gray-bg",
};

const iconColors: Record<BadgeColor, string> = {
  white: "text-badge-white-icon",
  pink: "text-badge-pink-icon",
  green: "text-badge-green-icon",
  blue: "text-badge-blue-icon",
  amber: "text-badge-amber-icon",
  purple: "text-badge-purple-icon",
  red: "text-badge-red-icon",
  gray: "text-badge-gray-icon",
};

const Badge = ({
  children, type = BadgeType.label, color = BadgeColor.white, disabled = false,
}: PropsWithChildren<BadgeProps>) => (
  <div
    className={`flex w-fit py-0.5 pr-2 rounded-sm border border-overlay items-center
      ${type === BadgeType.dotted ? "space-x-0" : "space-x-0.5"}
      ${disabled ? "bg-bg-disabled text-text-disabled border-border-disabled" : `${backgroundColors[color]} ${iconColors[color]}`} 
      ${type === BadgeType.label ? "pl-2" : "pl-0.5"}`}
  >
    {type === BadgeType.icon && (<IconInfoCircle />)}
    {type === BadgeType.dotted && (<IconPointFilled />)}
    <span className="typography-small-base">{children}</span>
  </div>
);

export default Badge;
